
$(function(){
	var action = function(e) {
		if($(this).val() == 1) {
			$('#shop-url-optional').show();
			$('#shop-url-required').hide();
		}else {
			$('#shop-url-required').show();
			$('#shop-url-optional').hide();
		}
	}
	for( var a=document.getElementsByName("topic"),i=a.length; i--; ) {
		a[i].addEventListener( "change", action ) ;
	}

	$('#close-window-btn').on('click', function(e) {
		if (/Chrome/i.test(navigator.userAgent)) {
			window.close();
		}else {
			window.open('about:blank', '_self').close();
		}
	});

});

